import evaluationSaga from './evaluation-saga';

export default evaluationSaga;
